import PAButton from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./about-us.module.scss";

const links = [
  {
    href: "/about-us",
    title: "About Parts Avatar",
    description: "Get to know the mission and history of Parts Avatar and some facts about us.",
    button: "Learn More",
    image: "about-us-icon",
  },
  {
    href: "/team",
    title: "Parts Avatar Team",
    description: "Get to know the team that is working hard to save your time and money in car repairs.",
    button: "Learn More",
    image: "team-icon",
  },
  {
    href: "/careers",
    title: "Careers",
    description: "We love what we do and we're always looking out for amazing people to join our team.",
    button: "See Openings",
    image: "careers-icon",
  },
];

function LearnMore() {
  const { t } = useTranslation("static-pages");
  const router = useRouter();

  return (
    <div className={`${styles.section} ${styles.team_section}`}>
      <PAText fontSize={FONT_SIZE[0]}>
        {t("LEARN MORE ABOUT US")}
      </PAText>
      <PAText
        component="h1"
        color="black"
        bold
        className={styles.section_header}
      >
        {t("Who we are and what we stand for")}
      </PAText>
      <div className={styles.team_section_links}>
        {links
          .filter((link) => link.href !== router.asPath)
          .map((link) => (
            <div key={link.href} className={styles.team}>
              <div onClick={() => router.push(link.href)}>
                <PAImage src={getRelativeImagePath(`/cms/pubicImages/images/${link.image}.webp`)} alt={link.title} width={200} height={200} />
              </div>
              <PAText bold fontSize={FONT_SIZE[2]}>
                {t(link.title)}
              </PAText>
              <PAText>{t(link.description)}</PAText>
              <PAButton className={styles.team_button} onClick={() => router.push(link.href)}>
                {t(link.button)}
              </PAButton>
            </div>
          ))}
      </div>
    </div>
  );
}
export default LearnMore;
